<template>
    <div class="unauth-user-list">
        <!-- 左边部门树 -->
        <div class="left-org">
          <div class="tit">
              业务分类
          </div>
          <div class="tree-body">
             <BusinessTree
                 :data="treeData"
                 :defaultProps="defaultProps"
                 @nodeClick="handleTreeNode"
             />
          </div>
        </div>
        <!-- 中间未授权人员列表 -->
        <div class="center-user">
              <div class="tit">
                  流程方案
              </div>
              <div class="searchUn">
                <div class="tools-search" @keyup.enter="handleSearch">
                    <el-form :inline="true" class="demo-form-inline">
                         <el-form-item label="流程定义">
                            <el-select style="width: 140px;" v-model="searchParams.processDefinitionId" clearable @change="handleSearch" placeholder="请选择">
                                <el-option
                                v-for="item in processDefineSearchList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="发布状态">
                            <el-select style="width:100px;" v-model="searchParams.state" clearable @change="handleSearch" placeholder="请选择">
                                <el-option
                                    v-for="item in processState"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="流程方案">
                            <el-input maxlength="100" style="width: 180px;" v-model.trim="searchParams.serviceName" placeholder="">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
              </div>
              <div class="data-body">
                    <el-table :data="processLists" style="width: 100%;" :border="true" v-loading="loading" :height="'51vh'"  @selection-change="handleSelectionApp">
                        <el-table-column
                          type="selection"
                          width="40">
                        </el-table-column>
                        <el-table-column prop="serviceName" label="流程方案名称" :show-overflow-tooltip="true" width="180"></el-table-column>
                        <el-table-column prop="definitionName" label="所属流程定义" :show-overflow-tooltip="true" width="150"></el-table-column>
                        <el-table-column prop="businessName" label="业务分类" :show-overflow-tooltip="true" width="120" ></el-table-column>
                        <!-- <el-table-column prop="state" label="发布状态" width="80" >
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.state === 1" type="success">已发布</el-tag>
                                <el-tag v-if="scope.row.state === 0" type="info">未发布</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="processServiceUserNames" label="已授权" :show-overflow-tooltip="true" align="left" width="200"></el-table-column>
                        <!-- <el-table-column prop="trueName" label="创建人" width="70"></el-table-column> -->
                        <!-- <el-table-column prop="created" label="创建时间" :sortable="true" width="150"></el-table-column> -->
                    </el-table>
                    <el-row type="flex" justify="end" style="margin-top: 10px;">
                        <el-pagination
                            background
                            layout="total,sizes, prev, pager, next"
                            :total="pages.totalPageNum"
                            :current-page="pages.currentPage"
                            :page-size="pages.pageSize"
                            :page-sizes="[10, 20, 30, 50, 100]"
                            @current-change="queryFormData"
                            @size-change="queryFormDataByPageSize"
                        />
                    </el-row>
              </div>
        </div>
        <!-- 右边已选择人员列表 -->
        <div class="right-choose-user">
             <div class="tit">
                人员列表
             </div>
             <div class="data-body">
                <OrgUserTree @loadUserForms="loadUserForms" ref="orgUserTree" :showCheckbox="showCheckbox"></OrgUserTree>
             </div>
        </div>
    </div>
</template>

<script>
    import {getProcessServiceList} from '@/data-model';
    import OrgUserTree from '@/components/OrgUserTree/OrgUserTree';
    export default{
        data () {
            return {
                showCheckbox: true,
                loading: false,
                processLists: [],
                pages: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 0 // 总页数
                },
                userId: [],
                forms: [],
                searchParams: {
                    processDefinitionId: '',
                    serviceName: '',
                    producer: '',
                    serviceType: '',
                    state: 1,
                    unNeedAuth: 'true'
                }
            };
        },
        comments: {
            OrgUserTree
        },
        props: {
            treeData: {
                type: Array
            },
            defaultProps: {
                type: Object
            },
            permission: {
                type: Object
            },
            processList: {
                type: Array
            },
            processState: {
                type: Array
            },
            processDefineSearchList: {
                type: Array
            }
        },
        created () {
            // this.processLists = this.processList;
            // this.pages = this.page;
            this.searchParams.serviceType = '';
            this.handleSearch();
        },
        methods: {
            handleTreeNode (data, node, tree) {
                this.searchParams.serviceType = data.id;
                this.handleSearch();
            },
            queryFormData (currentPage) {
                this.pages.currentPage = currentPage;
                this._getFormData();
            },
            queryFormDataByPageSize (pageSize) {
                this.pages.pageSize = pageSize;
                this._getFormData();
            },
            async _getFormData () {
                this.loading = true;
                let formData = await getProcessServiceList(Object.assign({}, {
                    currentPage: this.pages.currentPage,
                    pageSize: this.pages.pageSize
                }, this.searchParams));
                this.processLists = formData.data;
                this.processServiceIds = formData.otherData ? formData.otherData.prosessServiceIds : '';
                this.pages = {
                    currentPage: formData.currentPage,
                    pageSize: formData.pageSize,
                    totalPageNum: formData.totalPageNum
                };
                this.loading = false;
            },
            loadUserForms (obj) {
                let userids = [];
                for (var i = 0; i < obj.length; i++) {
                    userids.push(obj[i].id);
                }
                this.userId = userids.join(',');
            },
            handleSearch () {
                this.queryFormData(1);
            },
            handleSelectionApp (rows) {
                let processServiceId = [];
                for (var i = 0; i < rows.length; i++) {
                    processServiceId.push(rows[i].id);
                }
                this.forms = processServiceId.join(',');
            },
            buildParam () {
                let param = {userId: this.userId, processServiceId: this.forms};
                return param;
            }
        }
    };
</script>

<style lang="less" scoped>
.unauth-user-list{
    height: 70vh;
    display: flex;
    .left-org{
       width: 20vw;
       height: 100%;
       overflow: auto;
       border: 1px solid #F0F0EE;
       .search-content{
           width: 92%;
           margin-left: 2%;
       }
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
    }
    .center-user{
       width: 60vw;
       margin-left:2vw;
       height: 100%;
       overflow: auto;
       border: 1px solid #F0F0EE;
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
       .search-content{
           width: 92%;
           margin-left: 2%;
           margin-bottom: 1vh;
       }
       .unUserTable{
           width: 96%;
           margin-left: 2%;
           .gutter{
               width: 14px!important;
           }
           .el-table--border{
               border: none!important;
           }
           .el-table--group{
               border: none!important;
           }

       }

    }
    .right-choose-user{
       width: 20vw;
       margin-left: 2vw;
       border: 1px solid #F0F0EE;
       height: 100%;
       overflow: auto;
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
       .unChooseUserTable{
           width: 96%;
           margin-left: 2%;
           .gutter{
               width: 14px!important;
           }
           .el-table--border{
               border: none!important;
           }
           .el-table--group{
               border: none!important;
           }
       }
       .data-body{
           /deep/ .tree-body{
               border: none;
               height: 100%;
           }
       }
    }

}
.dialog__body{
    padding-top: 10px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ProcessBatchAuth/ProcessBatchAuth.vue